import { Component } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-subscription-dialog',
  standalone: true,
  imports: [ButtonModule, DialogModule],
  template: `
    <div class="subscription-dialog">
      <div class="dialog-content">
        <div class="icon-container">
          <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #f39c12;"></i>
        </div>

        <h3>Subscription Required</h3>

        <p class="message">
          To access the ads search functionality, you need an active subscription. Please subscribe
          to continue using this feature.
        </p>

        <div class="button-group">
          <p-button
            label="Subscribe"
            icon="pi pi-check"
            (onClick)="onSubscribe()"
            styleClass="p-button-success"
          >
          </p-button>

          <p-button
            label="Cancel"
            icon="pi pi-times"
            (onClick)="onCancel()"
            styleClass="p-button-secondary"
          >
          </p-button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .subscription-dialog {
        padding: 1rem;
      }

      .dialog-content {
        text-align: center;
      }

      .icon-container {
        margin-bottom: 1rem;
      }

      h3 {
        margin: 0 0 1rem 0;
        color: #333;
        font-size: 1.5rem;
      }

      .message {
        margin: 0 0 2rem 0;
        color: #666;
        line-height: 1.5;
        font-size: 1rem;
      }

      .button-group {
        display: flex;
        gap: 1rem;
        justify-content: center;
        flex-wrap: wrap;
      }

      .button-group p-button {
        min-width: 120px;
      }

      @media (max-width: 480px) {
        .button-group {
          flex-direction: column;
          align-items: center;
        }

        .button-group p-button {
          width: 100%;
          max-width: 200px;
        }
      }
    `,
  ],
})
export class SubscriptionDialogComponent {
  private data: any;

  constructor(
    public ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
  ) {
    this.data = this.config.data || {};
  }

  onSubscribe(): void {
    if (this.data && this.data.onSubscribe) {
      this.data.onSubscribe();
    }
  }

  onCancel(): void {
    if (this.data && this.data.onCancel) {
      this.data.onCancel();
    }
  }
}
